// extracted by mini-css-extract-plugin
export default {"controller":"ResizeController_controller__xCeWI"};